@if (item().route) {
  <a
    class="menu-row"
    [class.menu-row-parent]="depth() === 0"
    [class.menu-row-divider]="depth() === 0 || isLastChild()"
    [style.padding-left.px]="paddingLeft()"
    [style.padding-right.px]="paddingRight()"
    [routerLink]="isViewingOther() ? null : item().route"
    routerLinkActive="menu-row-active"
    #rla="routerLinkActive"
    [activated]="rla.isActive"
    [class.menu-item-disabled]="isViewingOther()"
    [attr.aria-current]="rla.isActive ? 'page' : null"
    [attr.aria-disabled]="isViewingOther() ? true : null"
    (click)="!isViewingOther() && onLeafClick()"
  >
    @if (depth() === 0) {
      <mat-icon class="menu-row-icon" [svgIcon]="'sqep:' + item().icon" />
    }
    <span class="menu-row-label">{{ item().label }}</span>
  </a>
} @else {
  <button
    type="button"
    class="menu-row menu-row-parent"
    [class.menu-row-divider]="depth() === 0 || isLastChild()"
    [style.padding-left.px]="paddingLeft()"
    [style.padding-right.px]="paddingRight()"
    [class.menu-row-ancestor-active]="isActiveDescendant()"
    [class.menu-item-disabled]="isViewingOther()"
    [attr.aria-expanded]="expanded()"
    [attr.aria-disabled]="isViewingOther() ? true : null"
    (click)="!isViewingOther() && toggle()"
  >
    @if (depth() === 0) {
      <mat-icon class="menu-row-icon" [svgIcon]="'sqep:' + item().icon" />
    }
    <span class="menu-row-label">{{ item().label }}</span>
    <mat-icon
      class="menu-row-chevron"
      [class.menu-row-chevron-expanded]="expanded()"
      svgIcon="sqep:chevron-right"
    />
  </button>
  @if (expanded()) {
    <div class="menu-row-children" @expandContractMenu>
      @for (child of item().subMenu; track child.routeIdentifier ?? child.label; let last = $last) {
        <sqep-menu-item
          [item]="child"
          [depth]="depth() + 1"
          [isLastChild]="depth() === 0 && last"
          [isViewingOther]="isViewingOther()"
          [expanded]="openChild() === child"
          [inFlyout]="inFlyout()"
          (toggled)="onChildToggled(child)"
          (navigated)="onChildNavigated()"
        />
      }
    </div>
  }
}
